/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import { useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";


import moment from 'moment';

import Spinner from 'components/Spinner.js';


const useStyles = makeStyles({
  table: {
    border: '1px solid black',
    width: '90%',
    margin: '10px',
    'border-collapse': 'collapse',
    'page-break-after': 'auto',
  },
  th: {
    border: '1px solid black',
    'border-collapse': 'collapse',
  }, 
  tr: {
    'page-break-after': 'auto',
    'page-break-inside':'avoid',
  },
  td: {
    border: '1px solid black',
    'border-collapse': 'collapse',
    'page-break-after': 'auto',
    'page-break-inside':'avoid',
  },
  thead: {
    display: 'table-row-group'
  },
  theadRow: {
    height: '100px',
    visibility: 'hidden',
    '@media print': {
      '.noprint': {
         visibility: 'hidden',
      }
   }
  },
  tfootRow: {
    height: '15px',
    visibility: 'hidden',
    '@media print': {
        '.noprint': {
          visibility: 'hidden',
        }
    }
  },
  center: {
    // display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    'margin-left': '250px'
  },
  sigs: {
    //width: '90%',
    margin: '20px',
  },
  sigblock: {
    top: '100px',
    'page-break-after': 'auto',
    'page-break-inside':'avoid',
  },
  header: {
    '@media print': {
      position: 'fixed',
      'top': 0,
      //left: '250px'
    }
  },
  firstPageHeader: {
    'margin-top': '100px',
  },
  footer: {
    '@media print': {
      position: 'fixed',
      'bottom': 0
    }
  },
  printLink: {
    visibility: 'hidden',
    '@media print': {
      '.noprint': {
        visibility: 'hidden',
      }
    }
  }
});

export default function() {
  const { code } = useParams();
  const classes = useStyles();
  return <PickingList code={code} classes={classes} />
}

class PickingList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSpinner: true,
      showData: false,
      data: {}
    };
  }

  componentDidMount() {
    var $this = this;
    fetch('/api/shared/stockCountJobs/generatePickingList', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ reference_code: $this.props.code })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data,
            showSpinner: false,
            showData: true
          }, () => window.print());
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  render ()
  {
    var scj = this.state.data;
    // if (scj.lines) {
    //   for (let i = 0; i < 5; i++)
    //   scj.lines.push(...scj.lines);
    // }
    const classes = this.props.classes;
    return (
      <Fragment>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showData ?
        <Fragment>
          <div style={{width:'100%'}}>
            <a href='#' onClick={() => window.print()} className={classes.printLink}>Print</a>
            <div className={classes.header}>
              <div className={classes.center}><h5>{scj.LOCNCODE}</h5></div>
              <div className={classes.center}>{moment().format('YYYY MMMM Do')}</div><br/>
            </div>
            <div className={classes.firstPageHeader}>
              <div className={classes.center}>SOUTH-WEST REGIONAL HEALTH AUTHORITY</div><br/>
              <div className={classes.center}>INVENTORY TRANSFER DOCUMENT</div><br/>
            </div>
            <br/>
            <table  className={classes.table}>
              <thead>
                <tr className={classes.theadRow} />
                <tr className={classes.tr}>
                  <th className={classes.th}>Item Number</th>
                  <th className={classes.th}>Item Description</th>
                  <th className={classes.th}>UOM</th>
                  <th className={classes.th}>Consump.</th>
                  <th className={classes.th}>SOH</th>
                  <th className={classes.th}>Qty Req</th>
                  <th className={classes.th}>Qty Issued</th>
                  <th className={classes.th}>Lot #</th>
                  <th className={classes.th}>Expiry</th>
                </tr>
              </thead>
              <tbody>
                {scj.lines.map(l => {
                  return <tr key={l.ITEMNMBR}  className={classes.tr}>
                    <td className={classes.td}>{l.ITEMNMBR}</td>
                    <td className={classes.td}>{l.ITEMDESC}</td>
                    <td className={classes.td}>{l.UOM}</td>
                    <td className={classes.td}>{l.Consump}</td>
                    <td className={classes.td}>{l.SOH}</td>
                    <td className={classes.td}>{l.QtyReq}</td>
                    <td className={classes.td}></td>
                    <td className={classes.td}></td>
                    <td className={classes.td}></td>
                  </tr>
                })}
              </tbody>
              <tfoot>
                <tr className={classes.tfootRow} />
              </tfoot>
            </table><br/>
            <div className={classes.sigblock}>
              {['Prepared', 'Authorised', 'Transported', 'Received'].map(t =>
              <Fragment>
                <GridContainer className={classes.sigs}>
                <GridItem xs={5} sm={5} md={5}>
                  <div>{`${t} by: `.padEnd(40, '_')}</div>
                </GridItem>
                {/* <GridItem xs={3} sm={3} md={3}>
                  <div>_____________________</div>
                </GridItem> */}
                <GridItem xs={1} sm={1} md={1}>
                </GridItem>
                <GridItem xs={5} sm={5} md={5}>
                  <div>Date: _________________</div>
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                </GridItem>
              </GridContainer><br/>
            </Fragment>
              )}
            </div>

            <div className={classes.footer}>Issued by_________________ Date_______________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Checked by____________________ Date_______________</div>
          </div>
        </Fragment>
        :null }
      </Fragment>
    );
  }
}
